import React, { memo } from "react";
import { object, string } from "prop-types";
import { useSelector } from "react-redux";

import PointList from "components/PointList";
import ShapeList from "components/ShapeList";
import Member from "containers/Member";
import Tag from "containers/Tag";
import Attributes from "containers/attributes";
import Issues from "containers/Issues";
import AuditLogs from "containers/AuditLogs";

import {
  selectLabelerUserId,
  selectReviewerUserId,
} from "redux/image/selectors";
import { selectUserRole } from "redux/permission/selector";
import { USER_ROLES } from "helpers/constants";

import style from "../style.module.scss";

export default memo(LabelingTab);

LabelingTab.propTypes = {
  tabObj: object,
  activeTab: string,
};

function LabelingTab({ tabObj, activeTab }) {
  const labelerUserId = useSelector(selectLabelerUserId);
  const reviewerUserId = useSelector(selectReviewerUserId);
  const role = useSelector(selectUserRole);

  const isShowAuditLogs =
    role !== USER_ROLES.LABELER && role !== USER_ROLES.REVIEWER;

  return (
    <div
      className={style.tabContent}
      style={activeTab !== "labeling" ? { display: "none" } : {}}
    >
      {tabObj.box && (
        <div className={style.listContainer}>
          <ShapeList />
        </div>
      )}
      {tabObj["facial landmarks"] && false && (
        <div className={style.listContainer}>
          <PointList />
        </div>
      )}
      {tabObj.issues && (
        <div className={style.listContainer}>
          <Issues />
        </div>
      )}
      {(labelerUserId || reviewerUserId) && (
        <div className={style.listContainer}>
          <Member
            labelerUserId={labelerUserId}
            reviewerUserId={reviewerUserId}
          />
        </div>
      )}
      <div className={style.listContainer}>
        <Tag />
      </div>
      <div className={style.listContainer}>
        <Attributes />
      </div>
      {isShowAuditLogs && (
        <div className={style.listContainer}>
          <AuditLogs />
        </div>
      )}
    </div>
  );
}
